"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesFolderPropertiesOverlay = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_redux_1 = require("react-redux");
var PermissionsActions = require("@caddigital/sok-reducers/lib/actions/project/permissions");
var FilesFolderPropertiesOverlay_1 = require("components/sidemenus/FilesFolderPropertiesOverlay");
var mapStateToProps = function (state) { return ({
    filesFolderProperties: state.project.permissions.filesFolderProperties
}); };
var mapDispatchToProps = function (dispatch) { return ({
    closeOverlay: function () {
        return dispatch(PermissionsActions.PropertiesActions.closeOverlay());
    },
    save: function (file, schema, values, mode) {
        return dispatch(PermissionsActions.PropertiesActions.savePropertiesRequest(file, schema, values, mode));
    }
}); };
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.lifecycle)({
    shouldComponentUpdate: function (nextProps) {
        if (this.props.currentProject !== nextProps.currentProject ||
            this.props.metadata !== nextProps.metadata ||
            this.props.filesFolderProperties !== nextProps.filesFolderProperties) {
            return true;
        }
        return false;
    }
}), recompose_1.pure);
exports.FilesFolderPropertiesOverlay = enhance(function (props) {
    return React.createElement(FilesFolderPropertiesOverlay_1.FilesFolderProperties, props);
});
